module.exports = __webpack_public_path__ + "static/media/Logout.83e16f93.svg";